import React from "react";
import { Stethoscope } from "lucide-react";
import { SYMPTOMS } from "@/data/services";

export default function SymptomPicker({ onPick }) {
  return (
    <section
      data-testid="symptom-picker"
      className="relative py-20 lg:py-24 bg-[#0e0e0e] border-y border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(245,197,24,0.04),_transparent_60%)]" />
      <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#F5C518]/30 bg-[#F5C518]/5 mb-4">
            <Stethoscope className="w-3.5 h-3.5 text-[#F5C518]" />
            <span className="text-[11px] uppercase tracking-[0.18em] font-semibold text-[#F5C518]">
              Symptom Picker
            </span>
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl uppercase tracking-tighter">
            What&apos;s your car <span className="text-[#F5C518]">doing?</span>
          </h2>
          <p className="mt-3 text-sm text-neutral-400">
            Tap a symptom — we&apos;ll auto-select the right service and bring you back to booking.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5">
          {SYMPTOMS.map((s, i) => (
            <button
              key={s.label}
              data-testid={`symptom-${s.serviceId}-${i}`}
              onClick={() => onPick(s.label)}
              className="group px-4 py-2.5 rounded-full border border-white/10 bg-white/[0.03] hover:border-[#F5C518] hover:bg-[#F5C518]/10 text-sm font-medium transition-all"
            >
              <span className="text-neutral-200 group-hover:text-[#F5C518]">
                {s.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
